import { Injectable } from '@angular/core';
import { GraphqlService } from '@reconcept-platform/shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceGraphQLService extends GraphqlService {
  constructor() {
    super();
  }

  // TODO: remove class
}
